import { SalesTable } from '../components/sales/SalesTable'

export default function AdminSalesPage({
  onEdit,
  onDelete,
  onMessage,
  onAssignTarget,
  onViewTargets,
}) {
  return (
    <div className="flex flex-col gap-6">
      <SalesTable
        onEdit={onEdit}
        onDelete={onDelete}
        onMessage={onMessage}
        onAssignTarget={onAssignTarget}
        onViewTargets={onViewTargets}
      />
    </div>
  )
}
